module.exports = __webpack_public_path__ + "img/img-avatar-05.87e6c64f.png";